<template>
  <div class="rule" v-if="regList.length > 0">
    <h2>活动规则</h2>
    <ul>
      <li v-for="(item, key) in regList" :key="key">
        <label>{{key + 1}}</label>
        <span>{{item}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Rule",
  props: {
    regList: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
.rule{
  width: 1200px;
  margin: 78px auto 60px;
  padding: 34px 38px;
  background: #081259;
  border-radius: 15px;
  box-sizing: border-box;
  h2{
    color: #fff;
    font-size: 28px;
    font-weight: 400;
    line-height: 28px;
    padding-bottom: 10px;
  }
  ul{
    li{
      list-style: none;
      margin-top: 15px;
      label{
        display: inline-block;
        width: 18px;
        height: 18px;
        line-height: 18px;
        background: linear-gradient(204deg, #F4E2CE, #FFFFFF);
        border-radius: 50%;
        color: #0A235F;
        font-size: 13px;
        font-weight: 800;
        margin-right: 10px;
        text-align: center;
      }
      span{
        vertical-align: middle;
        color: #D1DDFC;
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
      }
    }
  }
}
</style>